import { useIsAutoConnecting, useActiveWalletConnectionStatus } from 'thirdweb/react';

/**
 * Blocks rendering until Thirdweb's auto-connect phase is complete.
 * Without this, routes render during the "unknown/connecting" phase
 * and can crash or show stale state before the wallet session is restored.
 */
export default function WalletGuard({ children }) {
  const isAutoConnecting = useIsAutoConnecting();
  const status = useActiveWalletConnectionStatus();

  // Auto-connect in progress — wait for it to resolve
  if (isAutoConnecting || status === 'unknown') {
    return <div className="wallet-guard-loading" />;
  }

  return children;
}
